import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-607507d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "history" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"color":"black","font-size":"xx-large"} }, "Histories", -1))
const _hoisted_3 = { class: "searchHistory" }
const _hoisted_4 = { class: "forSearchHistory" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { m: "4" }
const _hoisted_12 = { m: "t-0 b-2" }
const _hoisted_13 = { m: "t-0 b-2" }
const _hoisted_14 = { m: "t-0 b-2" }
const _hoisted_15 = { m: "t-0 b-2" }
const _hoisted_16 = { m: "t-0 b-2" }
const _hoisted_17 = { m: "t-0 b-2" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { m: "t-0 b-2" }
const _hoisted_20 = { m: "t-0 b-2" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { m: "t-0 b-2" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { key: 3 }

import {handleError, onMounted, onBeforeUnmount, ref, getCurrentInstance} from "vue";
import request from '@/api/index'
import store from '@/store'
import {router} from "@/router";
import {Search} from "@element-plus/icons-vue";
import {ElMessage} from "element-plus";
import * as echarts from "echarts";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const tableData=ref()
const search=ref("")
const expands=ref([])
const colors = [
  { color: '#FDACBE', percentage: 20 },
  { color: '#f56c6c', percentage: 40 },
  { color: '#e6a23c', percentage: 60 },
  { color: '#5cb87a', percentage: 80 },
  { color: '#20BD1C', percentage: 100 },
]

const model=ref("")
const type=ref("")
const createTimes = ref([])
const createTimeBegin=ref("")
const createTimeEnd=ref("")
const client=ref("")

const optionList = [
  {
    value: "vipa155_client1",
    label: "vipa155_client1"
  }, {
    value: "vipa155_client2",
    label: "vipa155_client2"
  }, {
    value: "NULL",
    label: "NULL"
  }
];

const clientOptionList = [
  {
    value: "Pruned --> Fine-tuned",
    label: "Pruned --> Fine-tuned"
  }, {
    value: "Directly Pruned",
    label: "Directly Pruned"
  }, {
    value: "Upload Raw Model",
    label: "Upload Raw Model"
  }
];

const resetData = () => {
  model.value = ""
  type.value = ""
  createTimes.value = []
  createTimeBegin.value = ""
  createTimeEnd.value = ""
  client.value = ""
  getTableData()
}


// 分页条数据模型
const total = ref(0)

//分页
const pageParamsForm = {
  page:1, //当前页
  limit:8 //每页记录数
}
const pageParams = ref(pageParamsForm)

// const getRowKeys = (row) => {
//   return row.id
// }

const expandChange = (row, expandedRows) => {
  // 使用 some() 方法来检查 rows 数组中是否存在满足条件的元素。
  // 遍历 expandedRows 数组中的每个元素 r ，并对每个元素执行条件判断 r.historyId === row.historyId。
  // 如果有至少一个元素满足条件，则 some() 方法的返回值为 true。如果没有任何元素满足条件，则返回值为 false。
  console.log("row: ", row)
  const isExpend = expandedRows.some(r => r.historyId === row.historyId)
  if (isExpend) {
    console.log("是展开命令！给expands数组添加id")
    expands.value.push(row.historyId)
    console.log("expands: ", expands.value)
    console.log("expandedRows: ", expandedRows)
  } else {
    console.log("是收回命令！给expands数组删除id")
    expands.value = expands.value.filter(data => data !== row.historyId);
    console.log("expands: ", expands.value)
    console.log("expandedRows: ", expandedRows)
  }
}

// const AddProduct = (row) => {
//   expands.value.push(row.historyId)
//   console.log("expands: ", expands.value)
// }

const getTableData = async () => {
  //
  // console.log("tableData", tableData.value)
  // console.log("标记")
  if(createTimes.value.length == 2) {
    createTimeBegin.value = createTimes.value[0]
    createTimeEnd.value = createTimes.value[1]
  }

  await request.post(`/history/findHistoryByUser/${pageParamsForm.page}/${pageParamsForm.limit}`,{
    username: store.state.username,
    model: model.value,
    type: type.value,
    createTimeBegin: createTimeBegin.value,
    createTimeEnd: createTimeEnd.value,
    client: client.value,
  })
      .then((response)=>{
        console.log(response)
        let originData=response.data.data.historyInfos.list
        total.value = response.data.data.historyInfos.total
        console.log("originData: ", originData)
        tableData.value=originData.filter(
            (data) => {
              // console.log(data.datasetName.toLowerCase(), search.value)
              return (!search.value.length) || data.datasetName.toLowerCase().includes(search.value.toString().toLowerCase())
            }
        )
        // tableData.value.forEach(item => {
        //   item.submitTime = new Date(item.submitTime);
        // });
        // tableData.value = tableData.value.map(row => ({ ...row, expanded: true }));
        store.commit('setHistoryRecords', tableData.value)
        console.log("tableData", tableData.value)
      })
      .catch((error)=>{
        console.error(error)
      })
}

//
// const { proxy: ctx } = getCurrentInstance()
//
// onMounted(() => {
//   //初始化图表
// // let myChart = echarts.init(document.getElementById('gpuChart') );
//   let myChart = echarts.init(ctx.$refs.gpuChartRef);
// // gpuChartRef
// //配置图表的参数
//   let option = {
//     title: {
//       text:'扇形图示例'
//     },
//     series : [
//       {
//         name:'数据',
//         type: 'pie' ,
//         radius: '50%',
//         data: [
//           {value: 335,  name:'数据1'},
//           {value: 310,  name:'数据2'},
//           {value: 234,  name:'数据3'}
//         ]
//       }
//     ]
//   };
// //使用配置项显示图表
//   myChart.setOption(option);
// })


// let intervalHistory: number | null = null;

// onMounted(() => {
//
//
// });

getTableData();

//先暂停了，后面再开放实时刷新

let intervalHistory = setInterval(getTableData, 2000);

onBeforeUnmount(() => {
  if (intervalHistory) {
    clearInterval(intervalHistory);
    intervalHistory = null;
  }
});



// const intervalHistory = setInterval(() => {
//   getTableData()
// }, 2000)

// getTableData()




// console.log("tableData", tableData.value)

// function handleDelete(index:any,recordData:any){
//   request.post('/history/delete',{
//     historyName: recordData.historyName,
//     username: store.state.username
//   })
//       .then((response)=>{
//         console.log("handleDelete", response)
//         tableData.value.splice(index, 1)
//       })
//       .catch((error)=>{
//         console.log("handleDelete", error)
//       })
// }

function getRecordDetail(index:any, recordData:any) {

  router.push({
    name: 'twodresult',
    params: {
      recordDatasetId: tableData.value[index].datasetId,
      recordName: recordData.historyName
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_select, {
        modelValue: client.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((client).value = $event)),
        class: "forSearchHistory",
        placeholder: "Select Client",
        size: "large",
        onChange: getTableData
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(optionList, (item) => {
            return _createVNode(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: type.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((type).value = $event)),
        class: "forSearchHistory",
        placeholder: "Select Task Type",
        size: "large",
        onChange: getTableData
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(clientOptionList, (item) => {
            return _createVNode(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_input, {
          onKeyup: _withKeys(getTableData, ["enter"]),
          modelValue: model.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model).value = $event)),
          style: {"width":"250px","height":"40px"},
          placeholder: "Fuzzy keywords of model name"
        }, null, 8, ["onKeyup", "modelValue"])
      ]),
      _createVNode(_component_el_form_item, { class: "forSearchHistory" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_date_picker, {
            modelValue: createTimes.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((createTimes).value = $event)),
            type: "daterange",
            "range-separator": "To",
            "start-placeholder": "Begin time",
            "end-placeholder": "End time",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            onChange: getTableData
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "SearchReset",
        type: "primary",
        plain: "",
        size: "large",
        onClick: getTableData
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Search ")
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "SearchReset",
        type: "warning",
        size: "large",
        plain: "",
        onClick: resetData
      }, {
        default: _withCtx(() => [
          _createTextVNode("Reset")
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      style: {"width":"100%"},
      border: false,
      "row-key": "historyId",
      "expand-row-keys": expands.value,
      onExpandChange: expandChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          "min-width": "60",
          fixed: "",
          prop: "username",
          label: "user name"
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "120",
          prop: "modelName",
          label: "model name"
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "60",
          label: "importance"
        }, {
          default: _withCtx((props) => [
            (props.row.importance!=='N/A')
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 0,
                  href: props.row.importanceLink,
                  type: "primary",
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.importance), 1)
                  ]),
                  _: 2
                }, 1032, ["href"]))
              : (_openBlock(), _createElementBlock("text", _hoisted_5, _toDisplayString(props.row.importance), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "60",
          label: "regularizer"
        }, {
          default: _withCtx((props) => [
            (props.row.pruner!=='N/A')
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 0,
                  href: props.row.prunerLink,
                  type: "primary",
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.pruner), 1)
                  ]),
                  _: 2
                }, 1032, ["href"]))
              : (_openBlock(), _createElementBlock("text", _hoisted_6, _toDisplayString(props.row.pruner), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "100",
          prop: "taskType",
          label: "task type"
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "80",
          prop: "submitTime",
          label: "submit time"
        }, {
          default: _withCtx((props) => [
            _createTextVNode(_toDisplayString(props.row.submitTime.split(' ')[0]), 1),
            _hoisted_7,
            _createTextVNode(_toDisplayString(props.row.submitTime.split(' ')[1]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "80",
          prop: "finishTime",
          label: "finish time"
        }, {
          default: _withCtx((props) => [
            (props.row.finishTime==='2000-01-14 00:00:00')
              ? (_openBlock(), _createElementBlock("text", _hoisted_8, "N/A"))
              : (_openBlock(), _createElementBlock("text", _hoisted_9, [
                  _createTextVNode(_toDisplayString(props.row.finishTime.split(' ')[0]), 1),
                  _hoisted_10,
                  _createTextVNode(_toDisplayString(props.row.finishTime.split(' ')[1]), 1)
                ]))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "60",
          prop: "client",
          label: "client"
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "50",
          label: "details",
          type: "expand"
        }, {
          default: _withCtx((props) => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(props.row.paramsChange), 1),
              _createElementVNode("p", _hoisted_13, _toDisplayString(props.row.flopsChange), 1),
              _createElementVNode("p", _hoisted_14, _toDisplayString(props.row.accChange), 1),
              _createElementVNode("p", _hoisted_15, _toDisplayString(props.row.lossChange), 1),
              _createElementVNode("p", _hoisted_16, [
                _createTextVNode("Unpruned model: "),
                _createVNode(_component_el_link, {
                  target: "_blank",
                  href: props.row.checkpointPath.includes('Torch-Pruning') ? 'http://pruning.vipazoo.cn/api/WorkSpace/' + props.row.checkpointPath.split('Torch-Pruning').slice(-1)[0] : 'http://pruning.vipazoo.cn/api/ckpt' + props.row.checkpointPath.split('checkpoints').slice(-1)[0],
                  underline: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "success",
                      plain: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Download")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["href"])
              ]),
              _createElementVNode("p", _hoisted_17, [
                _createTextVNode("Pruned model: "),
                (props.row.prunedPath!=='N/A')
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      target: "_blank",
                      href: 'http://pruning.vipazoo.cn/api/WorkSpace/'+props.row.prunedPath.split('Torch-Pruning').slice(-1)[0],
                      underline: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "success",
                          plain: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Download")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["href"]))
                  : (_openBlock(), _createElementBlock("text", _hoisted_18, " N/A "))
              ]),
              _createElementVNode("p", _hoisted_19, [
                _createTextVNode(" Structure before pruned: "),
                _createVNode(_component_el_link, {
                  target: "_blank",
                  href: 'http://pruning.vipazoo.cn/api/WorkSpace/'+props.row.structureBeforePruned.split('Torch-Pruning').slice(-1)[0],
                  underline: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "primary",
                      plain: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("View")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["href"])
              ]),
              _createElementVNode("p", _hoisted_20, [
                _createTextVNode(" Structure after pruned: "),
                (props.row.structureAfterPruned!=='N/A')
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      target: "_blank",
                      href: 'http://pruning.vipazoo.cn/api/WorkSpace/'+props.row.structureAfterPruned.split('Torch-Pruning').slice(-1)[0],
                      underline: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "primary",
                          plain: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("View")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["href"]))
                  : (_openBlock(), _createElementBlock("text", _hoisted_21, " N/A "))
              ]),
              _createElementVNode("p", _hoisted_22, [
                _createTextVNode(" Log file: "),
                (props.row.logPath!=='N/A')
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      target: "_blank",
                      href: 'http://pruning.vipazoo.cn/api/WorkSpace/'+props.row.logPath.split('Torch-Pruning').slice(-1)[0],
                      underline: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "primary",
                          plain: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("View")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["href"]))
                  : (_openBlock(), _createElementBlock("text", _hoisted_23, " N/A "))
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "status",
          "min-width": "130"
        }, {
          default: _withCtx((props) => [
            (props.row.status==='Sparse Learning...'||props.row.status==='Pruned, Fine-tuning...'||props.row.status==='Waiting'||props.row.status==='Need Approval')
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createVNode(_component_el_text, {
                    class: "mx-1",
                    type: "warning",
                    style: {"color":"#C0C0C0","font-weight":"bold"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(props.row.status), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : (props.row.status==='Failed'||props.row.status==='Rejected')
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createVNode(_component_el_text, {
                      class: "mx-1",
                      type: "danger",
                      style: {"color":"#AB140C","font-weight":"bold"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(props.row.status), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                : (props.row.status==='Pruned(completed)'||props.row.status==='Fine-tuned(completed)'||props.row.status==='Uploaded(completed)')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createVNode(_component_el_text, {
                        class: "mx-1",
                        type: "success",
                        style: {"color":"#67C23A","font-weight":"bold"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.status), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createVNode(_component_el_text, {
                        class: "mx-1",
                        type: "success",
                        style: {"color":"#FF8017","font-weight":"bold"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.status), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])),
            _createVNode(_component_el_progress, {
              "text-inside": true,
              class: "m-2",
              "stroke-width": 26,
              percentage: (100*props.row.currentEpoch/props.row.totEpoch).toFixed(1),
              color: colors
            }, null, 8, ["percentage"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "expand-row-keys"]),
    _createVNode(_component_el_pagination, {
      "current-page": pageParams.value.page,
      "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((pageParams.value.page) = $event)),
      "page-size": pageParams.value.limit,
      "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((pageParams.value.limit) = $event)),
      "page-sizes": [4, 8, 16, 32],
      onSizeChange: getTableData,
      onCurrentChange: getTableData,
      layout: "total, sizes, prev, pager, next",
      total: total.value,
      class: "pagination"
    }, null, 8, ["current-page", "page-size", "total"])
  ]))
}
}

})